/* global messg */
import { kea } from 'kea'
import { put } from 'redux-saga/effects'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'

import controller from './controller.rb'

export default kea({
  initScene: {
    scene: 'registrationLogin',

    transform: payload => ({
      urls: payload.urls,
      email: payload.email,
      error: payload.error,
      position: payload.position
    })
  },

  path: () => ['scenes', 'registrationLogin', 'index'],

  actions: () => ({
    submit: true,
    submitSuccess: true,
    setEmail: email => ({ email }),
    setPassword: password => ({ password }),
    submitFailure: error => ({ error }),
    setPosition: position => ({ position })
  }),

  reducers: ({ actions }) => ({
    urls: [{}, PropTypes.object, {}],

    email: [
      '',
      PropTypes.string,
      {
        [actions.setEmail]: (_, { email }) => email
      }
    ],

    error: [
      null,
      PropTypes.string,
      {
        [actions.submitFailure]: (_, { error }) => error,
        [actions.submit]: () => null,
        [actions.setEmail]: () => null,
        [actions.setPassword]: () => null,
        [actions.setPosition]: () => null
      }
    ],

    password: [
      '',
      PropTypes.string,
      {
        [actions.setPassword]: (_, { password }) => password
      }
    ],

    isSubmitting: [
      false,
      PropTypes.bool,
      {
        [actions.submit]: () => true,
        [actions.submitSuccess]: () => false,
        [actions.submitFailure]: () => false
      }
    ],

    redirecting: [
      false,
      PropTypes.bool,
      {
        [actions.submitSuccess]: () => true,
        [actions.setPosition]: () => false
      }
    ],

    position: [
      'login',
      PropTypes.string,
      {
        [actions.setPosition]: (_, { position }) => position
      }
    ]
  }),

  actionToUrl: ({ actions }) => ({
    [actions.setPosition]: ({ position }) => `/${position}`
  }),

  urlToAction: ({ actions }) => ({
    '/forgot': () => actions.setPosition('forgot'),
    '/login': () => actions.setPosition('login')
  }),

  takeLatest: ({ actions }) => ({
    [actions.submit]: function * () {
      const { submitFailure, submitSuccess, setPosition } = this.actions
      const { email, password, position } = yield this.get()

      try {
        if (position === 'login') {
          const response = yield controller.login({ email, password })

          if (response.success) {
            const redirectUrl = response.redirect

            window.location.href = redirectUrl

            // just in case do it one more time
            window.setTimeout(() => {
              window.location.href = redirectUrl
            }, 15000)

            yield put(submitSuccess())
          } else {
            yield put(submitFailure(response.error))
          }
        } else {
          const response = yield controller.sendResetMail({ email })

          if (response.success) {
            messg.success(response.notice, 4000)
            yield put(submitSuccess())

            if (response.redirect) {
              window.location.href = response.redirect
            } else {
              yield put(setPosition('login'))
            }
          }
        }
      } catch (error) {
        yield put(submitFailure(I18n.t('modals.error_text')))
      }
    }
  })
})
